<vcl-modal id="termsModal" [modalTitle]="terms.title" *ngIf="terms" [(showModal)]="showModal"
  [buttonLabels]="buttonLabelsModal" (modalButtonClick)="modalAction($event)">
  <p id="pdfText" [innerHtml]="terms.text"></p>
</vcl-modal>

<div class="capture-data">
  <div class="box_title">
    <h1 class="captureTitle" id="captureTitle">
      {{copyService.copies.form_contact_title_data}}
    </h1>
  </div>
  <form id="formContactInfo" class="form" [formGroup]="formGroup">

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_contact_name_label }}"
        msgErr="{{ copyService.copies.form_capture_name_error }}">
        <input vclInput placeholder="{{ copyService.copies.form_contact_name_placeholder }}" id="inputValueName"
          type="text" (input)="inputClientName()" formControlName="client_name">
      </vcl-form-field>
    </div>

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_capture_lastname_label }}"
        msgErr="{{ copyService.copies.form_capture_lastname_error }}">
        <input vclInput placeholder="{{ copyService.copies.form_capture_lastname_placeholder }}" id="inputValueLastname"
          type="text" (input)="inputClientLastname()" formControlName="client_lastname">
      </vcl-form-field>
    </div>

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_contact_id_number_label }}"
        msgErr="{{ copyService.copies.form_capture_id_error }}">
        <input vclInput placeholder="{{ copyService.copies.form_contact_id_number_placeholder }}" id="inputValueId"
          maxlength="10" type="text" (input)="inputClientId()" formControlName="number_id">
      </vcl-form-field>
    </div>

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-datepicker language="es"
          [dateLabel]="copyService.copies.form_capture_birthday_date_label"
          invalidDateErrorMessage="{{
            copyService.copies.form_capture_birthday_date_error
          }}"
          [selectedDate]="birthdayDate"
          (change)="reactiveDatePicker($event)"
          [maxDate]="minDateBirth"
          [minDate]="maxDateBirth"
          [required]="true"
          ></vcl-datepicker>
      <!-- <div class="note">{{ msg }}</div> -->
  </div>

  <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-datepicker language="es"
          [dateLabel]="copyService.copies.form_contact_expedition_date"
          invalidDateErrorMessage="{{
            copyService.copies.form_capture_birthday_date_error
          }}"
          [selectedDate]="expeditionDate"
          (change)="expeditionDatePicker($event)"
          [minDate]="maxDateBirth"
          [required]="true"
          ></vcl-datepicker>
      <!-- <div class="note">{{ msg }}</div> -->
  </div>

  <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
    <vcl-select class="select-gender" id="genderSelection" [placeholder]="copyService.copies.form_contact_gender" (change)="selectOption($event)" required>
      <vcl-select-option [id]="'genderSelection' + option.id" *ngFor="let option of genderOptions" [value]="option">
        {{ option.name }}
      </vcl-select-option>
    </vcl-select>
  </div>

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_contact_phone_label }}"
        msgErr="{{ copyService.copies.form_capture_phone_error }}">
        <input vclInput placeholder="{{ copyService.copies.form_contact_phone_placeholder }}" id="inputValuePhone"
          maxlength="10" type="text" (focus)="inputPhone($event)" (focusout)="outPhone($event)" formControlName="phone">
      </vcl-form-field>
      <div class="label_info">{{ copyService.copies.form_capture_phone_text }}</div>
    </div>

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_contact_email_label }}"
        msgErr="{{ copyService.copies.form_capture_email_error }}">
        <input vclInput placeholder="{{ copyService.copies.form_contact_email_placeholder }}" id="inputValueEmail"
          type="email" (input)="reactiveInputChangeEmail()" formControlName="email">
      </vcl-form-field>
      <div class="label_info">{{ copyService.copies.form_capture_email_text }}</div>
    </div>

    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div class="label_title">{{copyService.copies.form_capture_advisor_question}}</div>
        <div>
          <voxel-radio-button-group id="isAdvCode" class="radio-button-flex">
            <voxel-radio-button *ngFor="let selectionList of listAdvisor; let i=index; "
              [id]="'radioButtonID' + selectionList.label" radioName="adv_code"
              formControlName="codeAdvisor"
              [checked]="selectionList.checked"
              (change)="selectAdvisorCode($event)"
              [value]="selectionList.value"
              class="radio-button">{{selectionList.label}}</voxel-radio-button>
          </voxel-radio-button-group>
        </div>
    </div>

    <div *ngIf="advisorCodeInput"
      class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field [label]="copyService.copies.form_capture_advisor_code"
        [msgErr]="copyService.copies.form_capture_advisor_error">
        <input vclInput id="inputValueCodeAdvisor" type="text" ng-pattern="/^[a-zA-Z ]*$´+/" [maxlength]='18'
          [placeholder]="copyService.copies.form_capture_advisor_placeholder"
          (input)="reactiveInputChangeCode($event)" formControlName="codeAdvisor" [value]="vendorCodeNumber" onkeydown="return (
                              event.ctrlKey || event.altKey
                          || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false)
                          || (95<event.keyCode && event.keyCode<106)
                          || (event.keyCode==8) || (event.keyCode==9)
                          || (event.keyCode>34 && event.keyCode<40)
                          || (event.keyCode==46)
                          || (event.keyCode==189) )">
      </vcl-form-field>
    </div>

  </form>
  <div class="voxel-mb-m">
    <voxel-card class="terms_Card">
      <div class="terms_description_card" VoxelCardDescription>
        <div class="icon">
          <em class="icon-itaufonts_foco_inovacao"></em>
        </div>
        <div class="terms-description">
          {{ copyService.copies.back_document_link_terms_label }}
          <vcl-link [linkId]="'backDocTermsLink'" (click)="toggleModal()"
            [label]="copyService.copies.back_document_link_terms">
          </vcl-link>
        </div>
      </div>
    </voxel-card>
  </div>
</div>
<app-controls id="formContactInfoBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_contact_btn"
  [nextDisabled]="!formGroup.valid || !date_button" (next)="next()"></app-controls>